import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, ShadowType, Spacing } from "@snapchat/snap-design-system";

export const cardContainer = css`
    margin-top: 0;
    padding: ${Spacing.LG}px;
    box-shadow: ${ShadowType.REGULAR};
`;

export const inputStyle = css`
    flex: 1 1;

    padding-bottom: ${Spacing.MD}px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
`;

export const controlStyle = css`
    flex: 1 1;

    padding-bottom: ${Spacing.MD}px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
`;

// Fix dropdown input control styling, otherwise when hovering an item, it becomes bold which doesn't seem the best UX
export const dropDownInputStyle = css`
    &.sds-dropdown-input-base-dropdown.ant-select-dropdown
        .rc-virtual-list-holder-inner
        .ant-select-item-option-active
        .ant-select-item-option-content {
        font-weight: ${FontWeight.NORMAL};
    }

    &.sds-dropdown-input-base-dropdown.ant-select-dropdown
        .rc-virtual-list-holder-inner
        .ant-select-item-option-selected
        .ant-select-item-option-content {
        font-weight: ${FontWeight.MEDIUM};
    }
`;

export const Divider = styled.div`
    margin-bottom: ${Spacing.MD}px;
    border-bottom: 1px solid ${Colors.Gray.V150};
`;

export const subContainer = css`
    width: 100%;
    padding: ${Spacing.MD}px ${Spacing.MD}px;
`;

export const apiCardContainer = css`
    margin-top: 0;
    box-shadow: ${ShadowType.REGULAR};
`;

export const httpProcessorLabel = css`
    p {
        font-size: ${FontSizeInPx.COMPACT}px;
        font-style: italic;
    }
`;
